import { QueryClient } from '@tanstack/react-query';

/**
 * Single app-wide react-query client. Lives outside main.tsx so non-UI
 * code paths (e.g. the wake-word "start next" resolver in
 * `utils/nextAppointment.ts`) can read/seed the cache without pulling
 * the React entry module — avoids a circular import where main.tsx
 * imports App, App's tree imports utils/nextAppointment, which would
 * loop back into main.tsx.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 5 * 60 * 1000,
    },
  },
});
